// extracted by mini-css-extract-plugin
module.exports = {"readmorebannerbottom":"ReadMoreBannerBottom_readmorebannerbottom__EXL3G"};